import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  FIELD_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_SIZE } from "../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";

export const CodesSection = styled.div`
  margin-top: ${SPACING.five}px;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.three}px;
`;

export const CodesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  > h3 {
    margin: 0;
    font-size: ${FONT_SIZE.three};
    color: ${TEXT_COLORS.one};
  }

  > span {
    font-size: ${FONT_SIZE.one};
    color: ${TEXT_COLORS.three};
  }
`;

export const CreateRow = styled.div<{ $isMobileScreen?: boolean }>`
  display: grid;
  grid-gap: ${SPACING.two}px;
  align-items: center;
  ${({ $isMobileScreen }) =>
    $isMobileScreen
      ? css`
          grid-template-columns: 1fr 1fr;
          > *:last-child {
            grid-column: 1 / -1;
          }
        `
      : css`
          grid-template-columns: 1fr 1fr 140px;
        `}
`;

export const CodeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
`;

export const CodeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.two}px;
  padding: ${SPACING.two}px ${SPACING.three}px;
  background-color: ${FIELD_COLORS.one};
  border-radius: ${BORDER_RADIUS.five}px;
  font-size: ${FONT_SIZE.two};
`;

export const CodeLinkText = styled.div`
  color: ${TEXT_COLORS.three};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  > span {
    color: ${TEXT_COLORS.one};
  }
`;

export const CodeMeta = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;

  > .label {
    font-size: ${FONT_SIZE.xs};
    color: ${TEXT_COLORS.three};
  }
`;

export const CodeActions = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
  flex-shrink: 0;

  > button {
    border: 1px solid transparent;
    width: 32px;
    height: 32px;
    background-color: ${FIELD_COLORS.two};
    border-radius: ${BORDER_RADIUS.two}px;
    color: ${TEXT_COLORS.one};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s all ease-in-out;

    &:hover {
      border: 1px solid ${BORDER_COLORS.five};
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    > svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const EmptyCodes = styled.div`
  color: ${TEXT_COLORS.three};
  font-size: ${FONT_SIZE.two};
  padding: ${SPACING.two}px 0;
`;

export const ErrorText = styled.div`
  color: ${COLORS.negative.one};
  font-size: ${FONT_SIZE.one};
  /* API/error messages can be long — wrap instead of overflowing the column. */
  overflow-wrap: anywhere;
  word-break: break-word;
`;
